import { useCohort } from '@/components/user-context/helpers/cohorts.ts';
import { ExperimentView } from '@/utils/experiment/experiment-view';
import { experiments } from '@/utils/experiment/manifest';
import { useIsMobile } from '@/utils/useIsMobile';

import { SignupDefault } from '../../../components/signup-default';
import { LoggedInLoomExistingSitesUser } from '../existing-sites-user';
import { LoggedInLoomNewUser } from '../new-user';

export const LoggedInLoom = () => {
	const cohort = useCohort();
	const isMobile = useIsMobile(800);

	// Cohort not resolved yet (profile request in progress)
	if (cohort === undefined) {
		return null;
	}

	// BAU (unchanged by this experiment): new-user and existing-sites users
	// already receive the lofi Loom-backdrop experience on master, so they are
	// excluded from the experiment and always keep it. Mobile always falls back
	// to the default signup.
	if (isMobile) {
		return <SignupDefault />;
	}

	if (cohort === 'new-user') {
		return <LoggedInLoomNewUser />;
	}

	const isPreviouslyExcludedCohort =
		cohort === 'managed-user' || cohort === 'week-one-user' || cohort === 'upgrade-eligible-user';

	// loom-logged-in-signup-parity: the experiment only toggles the lofi
	// experience for cohorts that previously fell back to the default signup
	// (managed-user, week-one-user, upgrade-eligible-user). Treatment shows the
	// lofi Loom-backdrop form; control preserves BAU (the default signup).
	if (isPreviouslyExcludedCohort) {
		return (
			<ExperimentView
				experiment={experiments.loomLoggedInSignupParity}
				render={(isEnabled) => (isEnabled ? <LoggedInLoomExistingSitesUser /> : <SignupDefault />)}
			/>
		);
	}

	// All other (existing-sites) users already receive lofi on master (BAU).
	return <LoggedInLoomExistingSitesUser />;
};
